import { RegularReportPresentPage } from "@/features/regular-document/pages/RegularPresent";

const RegularPresent = () => {
  return <RegularReportPresentPage />;
};

export default RegularPresent;
